<template>
<v-app class="vuetify-layout">
    <div class="login" v-on:keyup.enter="submit" style="background-color: darkgray;">
        <div class="container">
            <div class="logo-container">
                <logo class="ml-1" :logo="$page.props.organization.settings.main_logo_path"></logo>
            </div>

            <div class="form-wrap">
                <v-alert v-if="form.hasErrors" color="red" type="error">
                    <ul>
                        <li v-for="error in form.errors" :key="error">{{error}}</li>
                    </ul>
                </v-alert>

                <form method="POST">
                    <h2 class="text-center font-weight-medium text--secondary pb-3 mb-3">{{ ($page.props.lang && $page.props.lang.login) || 'Sign In' }}</h2>
                    <label>{{ ($page.props.lang && $page.props.lang.email) || 'Email' }}</label>
                    <v-text-field v-model="form.email" outlined solo flat dense></v-text-field>
                    <label>{{ ($page.props.lang && $page.props.lang.password) || 'Password' }}</label>
                    <v-text-field v-model="form.password" outlined solo flat dense type="password" name="password"></v-text-field>
                <div class="remember">
                    <v-checkbox v-model="form.remember" :label="($page.props.lang &&  $page.props.lang.rememberMe) || 'Remember me'"></v-checkbox>
                </div>
                <div class="actions">
                    <inertia-link class="link" href="/password-forgotten">{{ ($page.props.lang && $page.props.lang.forgotYourPassword) || 'Forgot your password?' }}</inertia-link>
                    <v-btn color="primary" :loading="loading" @click="submit" class="button">{{ ($page.props.lang && $page.props.lang.login) || "Sign In" }}</v-btn>
                    </div>
                </form>
            </div>

            <div v-if="$page.props.organization.apple_url != '' || $page.props.organization.android_url != ''" class="app-badges">
                <a :href="$page.props.organization.android_url" target="_blank" v-if="$page.props.organization.android_url != ''">
                    <img src="/android_store.png" alt="App Store" class="app-store">
                </a>
                <a :href="$page.props.organization.apple_url" target="_blank" v-if="$page.props.organization.apple_url != ''">
                    <img src="/apple-store.svg" width="142" alt="App Store" class="app-store">
                </a>
            </div>
        </div>
    </div>
</v-app>
</template>

<script>
import Logo from '@/js/Components/Logo'
export default {
    components: {
        Logo
    },
    metaInfo() {
        return {
            title: this.$page.props.lang.login || "Sign In"
        }
    },
    data() {
        return{
            form: this.$inertia.form({
                email: null,
                password: null,
                remember: false,
            }),

            loading: false
        }
    },
    methods: {
        submit() {
            this.loading = true;
            this.form.post('/login', {
                preserveScroll: true,
                onFinish: visit => {
                    this.loading = false;
                }
            });


        }
    }
}
</script>

<style scoped>
.app-badges     {
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
    align-items: center;
}
</style>
